/* global google */

import 'rc-slider/assets/index.css'
import { FormControl, FormHelperText } from 'material-ui/Form'
import Input, { InputLabel }  from 'material-ui/Input'
import React, { Component } from 'react'
import Button from 'material-ui/Button'
import { MenuItem } from 'material-ui/Menu'
import PropTypes from 'prop-types'
import Select from 'material-ui/Select'
import Slider from 'rc-slider'
import TextField from 'material-ui/TextField'
// import queryString from 'query-string'
import { withStyles } from 'material-ui/styles'

const styles = theme => ({
  filterContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  filter: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '-webkit-justifyContent': 'center',
    '-moz-justifyContent': 'center',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    flex: '1 10rem',
    '&:active': {
      borderColor: 'black',
    },
    maxWidth: '38rem',
    '& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      '-moz-appearance': 'none',
      'appearance': 'none',
      'margin': 0,
    },
    '& input[type="number"]': {
      '-moz-appearance': 'textfield',
    },
  },
  sliderDiv: {
    flex: '1 100%',
    display: 'flex',
    alignItems: 'center',
    margin: '2rem 0',
  },
  sliderLabel: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  buttonDiv: {
    display: 'flex',
    margin: theme.spacing.unit,
    flex: '2 7rem',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '10rem',
  },
  button: {
    width: '100%',
  },
  formControl: {
    width: '100%',
  },
  optionsTextContainer: {
    flex: '0.5 3rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionsText: {
    background: 'none!important',
    color: 'inherit',
    border: 'none',
    padding: '0!important',
    font: 'inherit',
    cursor: 'pointer',
    fontSize: '0.85rem',
  },
  advancedFilters: {
    textAlign: 'left',
    paddingBottom: '1rem',
    fontFamily: 'Proxima Nova, sans-serif',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '70rem',
  },
  advancedFilterSelect: {
    paddingLeft: '0.55rem',
    flex: '1 100%',
  },
  '@media (min-width: 840px)': {
    textField: {
      maxWidth: '20rem',
    },
    sliderDiv: {
      flex: '1 20rem',
      maxWidth: '30rem',
    },
    advancedFilterSelect: {
      flex: '1 49%',
    },
  },
  '@media (min-width: 1040px)': {
    sliderDiv: {
      margin: '0 5rem',
    },
    advancedFilterSelect: {
      flex: '1 40%',
    },
  },
  '@media (min-width: 2000px)': {
    sliderDiv: {
      margin: '0 8.5rem',
    },
  },
  '@media (min-width: 2600px)': {
    sliderDiv: {
      margin: '0 12.4rem',
      maxWidth: '50rem',
    },
  },
  '@media (min-width: 3064px)': {
    sliderDiv: {
      maxWidth: '60rem',
    },
  },
})

const RangeSlider = Slider.createSliderWithTooltip(Slider)

const geocode = (zip) => new Promise((resolve, reject) => {
  if(!zip) return resolve({ 'lat': null, 'lng': null })
  const geocoder = new google.maps.Geocoder()
  geocoder.geocode({ address: zip }, (results, status) => {
    // console.log('Inside geocoder', { results, status })
    if(status === 'OK') {
      const lat = results[0].geometry.location.lat()
      const lng = results[0].geometry.location.lng()
      resolve({ lat, lng })
    } else {
      console.error(`Could not geocode '${zip}': ${status}`)
      reject({ status })
    }
  })
})

class MapFilter extends Component {
  constructor(props) {
    //Have to do the super() function and pass props to it
    super(props)
    this.state = {
      zip: props.zip ? props.zip : '',
      distance: props.distance ? props.distance : 250,
      showAdvFilters: false,
    }
  }

  onZipChange = (event) =>
    this.setState(({ zip: event.target.value }))

  onDistanceChange = (newDistance) =>
    this.setState(prevState => ({ distance: newDistance }))

  onAfterDistanceChange = (newDistance) => {
    if(this.props.history.location.pathname === '/interactive_map') {
      this.props.updateUrlParams(
        this.props.history,
        `/interactive_map
        ?zip=${this.state.zip}
        &distance=${newDistance}
        &lat=${this.props.mapCenter.lat}
        &lng=${this.props.mapCenter.lng}`.replace(/\s/g, '')
      )
    }
  }

  onMoreOptionsClick = () =>
    this.setState(prevState => ({ showAdvFilters: true }))

  onLessOptionsClick = () =>
    this.setState(prevState => ({ showAdvFilters: false }))

  onSearchClick = () => {
    if(this.props.zip !== '') {
      geocode(String(this.state.zip)).then(latLng => {
        this.props.updateUrlParams(
          this.props.history,
          `/interactive_map
          ?zip=${this.state.zip}
          &distance=${this.state.distance}
          &lat=${latLng.lat}
          &lng=${latLng.lng}`.replace(/\s/g, '')
        )
      }).catch(({ status }) =>
        alert(`
          The zipcode you entered returned: ${status.split('_').join(' ')}

          Please re-check your zipcode and try again.
        `)
      )
    }
  }

  updateFilterComms = (event) => {
    this.props.updateFilterComms(event.target.value)
  }

  updateFilterDists = (event) => {
    this.props.updateFilterDists(event.target.value)
  }

  //filterWithinFilteredFarms = (distributor) => 
  //  this.props.farms.map((farm) => {
  //    console.log('farm.distributors', farm.Distributors)
  //    console.log('distributor', distributor)
  //  })

  render() {
    const {
      classes,
      commodities,
      distributors,
      farms,
      filterClass,
      filterComms,
      filterDists,
      distance,
      mapCenter,
      zip,
      updateDistance,
      updateZip,
    } = this.props

    return (
      <div
        className={classes.filterContainer}
        style={{
          maxWidth: this.props.history.location.pathname === '/interactive_map' ? '70rem' : '100%',
          minWidth: this.props.history.location.pathname === '/interactive_map' ? '20rem' : '100%',
        }}
      >
        <div className={classes.filter}>
          <TextField
            className={classes.textField}
            label='Zip Code'
            margin='dense'
            onChange={this.onZipChange}
            type='number'
            value={this.state.zip}
          />
          <div className={classes.sliderDiv}>
            <span className={classes.sliderLabel}>
              0(Mi)
            </span>
            <RangeSlider
              className={classes.slider}
              max={500}
              min={0}
              onAfterChange={this.onAfterDistanceChange}
              onChange={this.onDistanceChange}
              value={this.state.distance}
            />
            <span className={classes.sliderLabel}>
              500(Mi)
            </span>
          </div>
          <div className={classes.buttonDiv}>
            <Button
              className={classes.button}
              dense
              onClick={this.onSearchClick}
              raised
            >
              Search
            </Button>
          </div>
          {this.props.history.location.pathname === '/interactive_map' &&
            this.state.showAdvFilters === false &&
            <div className={classes.optionsTextContainer}>
              <p>
                <button
                  className={classes.optionsText}
                  onClick={this.onMoreOptionsClick}
                >
                  More Options &#9660;
                </button>
              </p>
            </div>
          }
          {this.props.history.location.pathname === '/interactive_map' &&
            this.state.showAdvFilters === true &&
            <div className={classes.optionsTextContainer}>
              <p>
                <button
                  className={classes.optionsText}
                  onClick={this.onLessOptionsClick}
                >
                  Less Options &#9650;
                </button>
              </p>
            </div>
          }
        </div>
        {this.props.history.location.pathname === '/interactive_map' &&
          this.state.showAdvFilters === true &&
          <div className={classes.advancedFilters}>
            <div className={classes.advancedFilterSelect}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor='commoditySelect'>Commodities</InputLabel>
                <Select
                  MenuProps={
                    {
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 4.5 + 8,
                          width: 200,
                        },
                      },
                    }
                  }
                  input={<Input id='commoditySelect' />}
                  multiple
                  onChange={this.updateFilterComms}
                  value={filterComms}
                >
                  {
                    commodities.sort((a, b) => {
                      const nameA = a.Name.toUpperCase()
                      const nameB = b.Name.toUpperCase()
                      if(nameA < nameB) {
                        return -1
                      }
                      if(nameA > nameB) {
                        return 1
                      }
                      return 0
                    }).map((commodity) => (
                      <MenuItem
                        key={commodity.CommID}
                        value={commodity.CommID}
                      >
                        {commodity.Name}
                      </MenuItem>
                    ))
                  }
                </Select>
                <FormHelperText>Specific Commodities</FormHelperText>
              </FormControl>
            </div>
            <div className={classes.advancedFilterSelect}>
              <FormControl className={classes.formControl}>
                <InputLabel htmlFor='distributorSelect'>Distributors</InputLabel>
                <Select
                  MenuProps={
                    {
                      PaperProps: {
                        style: {
                          maxHeight: 48 * 4.5 + 8,
                          width: 200,
                        },
                      },
                    }
                  }
                  input={<Input id='distributorSelect' />}
                  multiple
                  onChange={this.updateFilterDists}
                  value={filterDists}
                >
                  {
                  distributors.filter(dist => farms.some(f => f.Distributors.map(d => d.DistID).includes(dist.DistID))).sort((a, b) => {
                      const nameA = a.Name.toUpperCase()
                      const nameB = b.Name.toUpperCase()
                      if(nameA < nameB) {
                        return -1
                      }
                      if(nameA > nameB) {
                        return 1
                      }
                      return 0
                    }).map((distributor) => (
                      <MenuItem
                        key={distributor.DistID}
                        value={distributor.DistID}
                      >
                        {distributor.Name}
                      </MenuItem>
                    ))
                  }
                </Select>
                <FormHelperText>Specific Distributor</FormHelperText>
              </FormControl>
            </div>
          </div>
        }
      </div >
    )
  }
}

MapFilter.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(MapFilter)



// WEBPACK FOOTER //
// ./src/components/MapFilter.js